import { useEffect, useRef, useState } from "react";
import { Box } from "@mui/material";

/**
 * Fade/slide-in when section enters viewport — keeps existing layout, adds motion on scroll.
 */
export default function ScrollReveal({
    children,
    className = "",
    delay = 0,
    direction = "up",
    threshold = 0.12,
    sx,
    ...props
}) {
    const ref = useRef(null);
    const [visible, setVisible] = useState(false);

    useEffect(() => {
        const el = ref.current;
        if (!el) return undefined;

        const observer = new IntersectionObserver(
            ([entry]) => {
                if (entry.isIntersecting) {
                    setVisible(true);
                    observer.unobserve(el);
                }
            },
            { threshold, rootMargin: "0px 0px -48px 0px" }
        );

        observer.observe(el);
        return () => observer.disconnect();
    }, [threshold]);

    return (
        <Box
            ref={ref}
            className={`scroll-reveal scroll-reveal--${direction} ${visible ? "scroll-reveal--visible" : ""} ${className}`}
            sx={{ transitionDelay: `${delay}ms`, ...sx }}
            {...props}
        >
            {children}
        </Box>
    );
}
